import { render } from "./Office.vue?vue&type=template&id=66866214"
const script = {}

import exportComponent from "/home/ubuntu/projects/sms_agent/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__